// node-modules
import 'particles.js';
import 'whatwg-fetch';

// assets
import './particles.scss';

const initParticles = (id, settings) => {
  fetch(settings)
    .then(data => data.json())
    .then((params) => {
      // eslint-disable-next-line no-undef
      particlesJS(id, params);
    })
    .catch((err) => {
      console.error('Something went wrong', err);
    });
};

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-component="particles"]')
    .forEach((element, i) => {
      const id = `particles-js-${i}`;
      element.classList.add('particles-js-container');
      element.setAttribute('id', id);
      const { settings } = element.dataset;
      initParticles(id, settings);
    });
});
